import BasicLayout from '@/layouts/basic-layout'

const prefix = 'project-receivable-application-'
export default {
  path: '/financial-manage/project-receivable-application',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '项目收款管理'},
      component: () => import('@/pages/financial-manage/project-receivable-application/index')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {cache: true, title: '项目收款编辑'},
      component: () => import('@/pages/financial-manage/project-receivable-application/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '项目收款详情'},
      component: () => import('@/pages/financial-manage/project-receivable-application/detail-view')
    }
  ]
}
